
interface Video {
  id: string
  title: string
  thumbnail: string
  duration: string
  category: string
  tags: string[]
  youtubeId: string
}

interface TagCategory {
  id: string
  name: string
  videos: Video[]
  count: number
}

const TagsPage = () => {
  // Note: selectedTag state is prepared for future functionality

  // Sample video data organized by tags
  const tagCategories: TagCategory[] = [
    {
      id: 'interview',
      name: 'インタビュー系統',
      count: 4,
      videos: [
        {
          id: 'int1',
          title: 'インタビュー項目の作成',
          thumbnail: '',
          duration: '10:30',
          category: 'interview',
          tags: ['インタビュー', '項目', '作成'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'int2',
          title: 'インタビューここで人材',
          thumbnail: '',
          duration: '15:45',
          category: 'interview',
          tags: ['インタビュー', '人材', '実践'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'int3',
          title: 'アンケートの実施',
          thumbnail: '',
          duration: '12:20',
          category: 'interview',
          tags: ['アンケート', '実施', 'リサーチ'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'int4',
          title: 'アンケート結果の整理',
          thumbnail: '',
          duration: '8:15',
          category: 'interview',
          tags: ['アンケート', '結果', '整理'],
          youtubeId: 'dQw4w9WgXcQ'
        }
      ]
    },
    {
      id: 'basics',
      name: '基礎編（件)',
      count: 4,
      videos: [
        {
          id: 'bas1',
          title: 'インタビュー項目の作成',
          thumbnail: '',
          duration: '10:30',
          category: 'basics',
          tags: ['基礎', '項目', '作成'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'bas2',
          title: 'インタビューここで人材',
          thumbnail: '',
          duration: '15:45',
          category: 'basics',
          tags: ['基礎', '人材', '実践'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'bas3',
          title: 'アンケートの実施',
          thumbnail: '',
          duration: '12:20',
          category: 'basics',
          tags: ['基礎', '実施', 'リサーチ'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'bas4',
          title: 'アンケート結果の整理',
          thumbnail: '',
          duration: '8:15',
          category: 'basics',
          tags: ['基礎', '結果', '整理'],
          youtubeId: 'dQw4w9WgXcQ'
        }
      ]
    },
    {
      id: 'survey',
      name: 'アンケート設計（4件)',
      count: 4,
      videos: [
        {
          id: 'sur1',
          title: 'インタビュー項目の作成',
          thumbnail: '',
          duration: '10:30',
          category: 'survey',
          tags: ['アンケート', '設計', '作成'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'sur2',
          title: 'インタビューここで人材',
          thumbnail: '',
          duration: '15:45',
          category: 'survey',
          tags: ['アンケート', '人材', '実践'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'sur3',
          title: 'アンケートの実施',
          thumbnail: '',
          duration: '12:20',
          category: 'survey',
          tags: ['アンケート', '実施', 'リサーチ'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'sur4',
          title: 'アンケート結果の整理',
          thumbnail: '',
          duration: '8:15',
          category: 'survey',
          tags: ['アンケート', '結果', '整理'],
          youtubeId: 'dQw4w9WgXcQ'
        }
      ]
    },
    {
      id: 'practical',
      name: '実践課題の整理（2件)',
      count: 2,
      videos: [
        {
          id: 'pra1',
          title: 'インタビュー項目の作成',
          thumbnail: '',
          duration: '10:30',
          category: 'practical',
          tags: ['実践', '課題', '整理'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'pra2',
          title: 'インタビューここで人材',
          thumbnail: '',
          duration: '15:45',
          category: 'practical',
          tags: ['実践', '課題', '人材'],
          youtubeId: 'dQw4w9WgXcQ'
        }
      ]
    },
    {
      id: 'creation',
      name: 'お企画作り（3件)',
      count: 3,
      videos: [
        {
          id: 'cre1',
          title: 'インタビュー項目の作成',
          thumbnail: '',
          duration: '10:30',
          category: 'creation',
          tags: ['企画', '作成', '計画'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'cre2',
          title: 'インタビューここで人材',
          thumbnail: '',
          duration: '15:45',
          category: 'creation',
          tags: ['企画', '人材', '実践'],
          youtubeId: 'dQw4w9WgXcQ'
        },
        {
          id: 'cre3',
          title: 'アンケートの実施',
          thumbnail: '',
          duration: '12:20',
          category: 'creation',
          tags: ['企画', '実施', 'リサーチ'],
          youtubeId: 'dQw4w9WgXcQ'
        }
      ]
    }
  ]

  const VideoCard = ({ video }: { video: Video }) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
      <div className="relative">
        <div className="w-full h-32 bg-gradient-to-br from-orange-400 to-yellow-400 flex items-center justify-center">
          <div className="text-white text-3xl">🎬</div>
        </div>
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded">
          {video.duration}
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-semibold text-sm text-gray-900 mb-2 line-clamp-2">
          {video.title}
        </h3>
        <div className="text-xs text-gray-500 mb-1">
          アントレ部 • 教育
        </div>
        <div className="text-xs text-gray-400">
          視聴時間: {video.duration}
        </div>
      </div>
    </div>
  )

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Main Content */}
          <div className="md:col-span-3">
            {/* Page Header */}
            <div className="mb-6">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">タグ一覧</h1>
              <p className="text-gray-600">カテゴリ・タグ</p>
            </div>

            {/* Tag Categories */}
            <div className="space-y-8">
              {tagCategories.map((category) => (
                <div key={category.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                  {/* Category Header */}
                  <div className="bg-gray-100 px-4 py-3 border-b">
                    <h2 className="font-semibold text-gray-900">{category.name}</h2>
                  </div>
                  
                  {/* Videos Grid */}
                  <div className="p-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      {category.videos.map((video) => (
                        <VideoCard key={video.id} video={video} />
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="md:col-span-1">
            <div className="space-y-4">
              {/* Search by Tag Action */}
              <div className="bg-white rounded-lg shadow-md p-4">
                <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-3 mb-4">
                  <div className="flex items-center">
                    <span className="text-yellow-600 mr-2">📋</span>
                    <span className="text-sm font-medium text-yellow-800">
                      選択したタグでコン<br />
                      ゼクト検索
                    </span>
                  </div>
                </div>
                
                <div className="text-sm text-gray-600 mb-3">
                  タグの検索はスライ<br />
                  ス条件表示
                </div>
                
                <button className="w-full bg-cyan-500 hover:bg-cyan-600 text-white text-sm py-2 px-4 rounded-md">
                  選択したタグでコンテン<br />
                  ツ検索
                </button>
              </div>

              {/* Content that doesn't match */}
              <div className="bg-white rounded-lg shadow-md p-4">
                <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-3 mb-4">
                  <div className="flex items-center">
                    <span className="text-yellow-600 mr-2">❗</span>
                    <span className="text-sm font-medium text-yellow-800">
                      該当しないができ<br />
                      コンテンツのアクセス<br />
                      表示
                    </span>
                  </div>
                </div>
                
                <div className="text-sm text-gray-600">
                  該当しないができないコンテン<br />
                  ツのアクセス表示
                </div>
              </div>

              {/* Popular Tags */}
              <div className="bg-white rounded-lg shadow-md p-4">
                <h3 className="font-semibold text-gray-900 mb-3">人気のタグ</h3>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">インタビュー</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">12</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">アンケート</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">8</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">基礎</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">15</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">実践</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">6</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">企画</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">9</span>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="bg-white rounded-lg shadow-md p-4">
                <h3 className="font-semibold text-gray-900 mb-3">クイックアクション</h3>
                <div className="space-y-2">
                  <button className="w-full text-left text-sm text-gray-600 hover:text-gray-900 py-1">
                    すべてのタグを表示
                  </button>
                  <button className="w-full text-left text-sm text-gray-600 hover:text-gray-900 py-1">
                    人気順に並び替え
                  </button>
                  <button className="w-full text-left text-sm text-gray-600 hover:text-gray-900 py-1">
                    新着順に並び替え
                  </button>
                  <button className="w-full text-left text-sm text-gray-600 hover:text-gray-900 py-1">
                    お気に入りタグ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TagsPage